import { pb } from "$lib/pocketbase";

export const ROLES = {
  ADMIN: "Admin",
  DEVELOPER: "Developer",
  USER: "User"
};
const ROLE_PRIORITY = {
  [ROLES.ADMIN]: 3,
  [ROLES.DEVELOPER]: 2,
  [ROLES.USER]: 1
};

const roleCache = new Map<string, Promise<any>>();

export const PERMISSIONS = {
  CREATE_CONFIGS: "create:configs",
  UPLOAD_CONFIGS: "upload:configs",
  DELETE_CONFIGS: "delete:configs"
};

export const rolePermissions = {
  [ROLES.ADMIN]: [
    PERMISSIONS.CREATE_CONFIGS,
    PERMISSIONS.UPLOAD_CONFIGS,
    PERMISSIONS.DELETE_CONFIGS
  ],
  [ROLES.DEVELOPER]: [PERMISSIONS.CREATE_CONFIGS, PERMISSIONS.UPLOAD_CONFIGS]
};

// Function to check if a user has a specific role
export async function checkRole(user: any, requiredRole: any) {
  if (user == null || !user.role) {
    return false;
  }

  try {
    if (!roleCache.has(user.role)) {
      roleCache.set(user.role, pb.collection("roles").getOne(user.role));
    }
    const roleRecord = await roleCache.get(user.role);
    return ROLE_PRIORITY[roleRecord.name] >= ROLE_PRIORITY[requiredRole];
  } catch (error) {
    console.warn("Error fetching role:", error);
    roleCache.delete(user.role);
    return false;
  }
}

// Function to check if a user has specific permissions
export async function checkPermissions(user: any, requiredPermissions: any) {
  if (user == null || !user.role) {
    return false;
  }

  try {
    const roleRecord = await pb.collection("roles").getOne(user.role);
    const roleKey = Object.keys(ROLES).find(
      (key: string) => ROLES[key] === roleRecord.name
    );

    if (!roleKey) {
      return false;
    }

    const userPermissions = rolePermissions[roleKey];
    console.log("user hat permissions", userPermissions);
    return userPermissions?.includes(requiredPermissions);
  } catch (error) {
    console.error("Error fetching role for permissions check:", error);
    return false;
  }
}

// Function to check if a user has both a specific role and permissions
export async function checkRoleAndPermissions(
  user: any,
  requiredRole: any,
  requiredPermissions: any
) {
  return (
    (await checkRole(user, requiredRole)) &&
    checkPermissions(user, requiredPermissions)
  );
}
